import Pills from './Pills'

export default Pills
